import { useLabraChatSelector } from '../../../modules/labraChat/context'

/**
 * Logged-in user's IANA timezone from Redux (same source as Labra
 * `useUserDisplayTimeZone` in the host app).
 * Primary: `userProfile.timeZone`; fallback: `defaultTimeZone`, then `UTC`.
 */
export const useUserDisplayTimeZone = (): string =>
  useLabraChatSelector(state => {
    const profile = state.userProfile?.userProfile
    const raw = profile?.timeZone ?? profile?.defaultTimeZone
    const trimmed = raw != null ? String(raw).trim() : ''
    return trimmed || 'UTC'
  })
